import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { RenderNavItem } from "../components/RenderNavItem";
import { UttaranServicesLeftMenuList } from "../utils/constants";

const KMC_Bustee_services = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
        </div>
      </section>
      {/* End Slider */}

      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {UttaranServicesLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="">
                  <div className="inner-title">
                    <h3 className="fontSizeClass">Uttaran Services :: FAQs</h3>
                  </div>
                  <section id="faq" className="faq advertisement">
                    <div className="">
                      <div className="row gy-4">
                        <div className="col-lg-12 d-flex flex-column justify-content-center align-items-stretch  order-2 order-lg-1 no-margin">
                          <div id="accordion">
                            <div className="card">
                              <div className="card-header" id="heading1">
                                <button
                                  className="btn btn-link fontSizeClass  m-2"
                                  data-toggle="collapse"
                                  data-target="#collapse1"
                                  aria-expanded="true"
                                  aria-controls="collapse1"
                                >
                                  1. What are the key activities of the
                                  department?
                                </button>
                              </div>
                              <div
                                id="collapse1"
                                className="collapse show"
                                data-parent="#accordion"
                              >
                                <div class="card-body m-3">
                                  <ul className="kmc-function-list">
                                    {[
                                      {
                                        label:
                                          "Physical improvement / augmentation of the municipal services in the slum areas under the different GoI & GoWB schemes",
                                        children: [
                                          "Basic Minimum Services Programme",
                                          "National Slum Development Programme",
                                          "Tenth Finance Commission Schemes",
                                        ],
                                      },
                                      {
                                        label:
                                          "Monitoring & maintenance of municipal services to the slum areas under different GoI / GoWB & KMC schemes",
                                      },
                                      {
                                        label:
                                          "Implementation and co-ordination of programme / schemes of GOI & GoWB",
                                      },
                                      {
                                        label:
                                          "Carry out survey under the KMC area on Demographic, socio-economic & and level of services provided",
                                      },
                                      {
                                        label:
                                          "Beneficiary’s identification etc under BSUP of JNNURM",
                                      },
                                      {
                                        label: "Wage Employment Programme",
                                      },
                                      {
                                        label:
                                          "Construction and maintenance of Pay & Use toilets",
                                      },
                                      {
                                        label:
                                          "Construction of Community Hall.",
                                      },
                                    ].map((item, index) => (
                                      <li key={index}>
                                        {item.label}
                                        {item.children && (
                                          <ul className="kmc-function-list">
                                            {item.children.map((subItem, i) => (
                                              <li key={i}>{subItem}</li>
                                            ))}
                                          </ul>
                                        )}
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div class="card">
                              <div className="card-header" id="heading2">
                                <button
                                  className="btn btn-link fontSizeClass  m-2"
                                  data-toggle="collapse"
                                  data-target="#collapse2"
                                  aria-expanded="true"
                                  aria-controls="collapse2"
                                >
                                  2. What are the different types of slum
                                  infrastructure development works undertaken?
                                </button>
                              </div>
                              <div
                                id="collapse2"
                                class="collapse"
                                aria-labelledby="heading2"
                                data-parent="#accordion"
                              >
                                <div class="card-body m-3">
                                  The role of the Uttaran Services is to facilitate
                                  <ul className="kmc-function-list">
                                    {[
                                      "Supply of adequate drinking water by arranging for community tube-wells and community water taps.",
                                      "Improvement of the sewerage & drainage system of the Bustees including conversion of kuchha surface drain intounder-ground pipe sewerage.",
                                      "Improvement of existing passage as well as construction of new passage including conversion of kuchha passage into pucca road.",
                                      "Construction of new community latrines and repairing of existing community latrine",
                                      "Illumination of slum lanes, by-lanes and passages by providing streetlight, mini pole etc.",
                                      "Construction of Community Hall for the slum dwellers",
                                    ].map((item, index) => (
                                      <li key={index}>{item}</li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div class="card">
                              <div className="card-header" id="heading3">
                                <button
                                  className="btn btn-link fontSizeClass  m-2"
                                  data-toggle="collapse"
                                  data-target="#collapse3"
                                  aria-expanded="true"
                                  aria-controls="collapse3"
                                >
                                  3. Whom should I contact for the above types
                                  of work?
                                </button>
                              </div>
                              <div
                                id="collapse3"
                                class="collapse"
                                aria-labelledby="heading3"
                                data-parent="#accordion"
                              >
                                <div class="card-body m-3">
                                  You may contact the following :
                                  <ul className="kmc-function-list">
                                    <li> Local Ward officer </li>
                                    or
                                    <li>
                                      Concerned Borough Executive Engineer
                                    </li>
                                    or
                                    <li>Uttaran Services Director-General</li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div class="card">
                              <div className="card-header" id="heading4">
                                <button
                                  className="btn btn-link fontSizeClass  m-2"
                                  data-toggle="collapse"
                                  data-target="#collapse4"
                                  aria-expanded="true"
                                  aria-controls="collapse4"
                                >
                                  4. How should I apply to avail the above
                                  civic-infrastructure facilities?
                                </button>
                              </div>

                              <div
                                id="collapse4"
                                class="collapse"
                                aria-labelledby="heading4"
                                data-parent="#accordion"
                              >
                                <div class="card-body m-3">
                                  You can avail of the facilities by :
                                  <ul className="kmc-function-list">
                                    {[
                                      "submitting a written complaint to local ward officer or by",
                                      "entering your complaint in the local ward office complaint register",
                                    ].map((item, index) => (
                                      <li key={index}>{item}</li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div class="card">
                              <div className="card-header" id="heading5">
                                <button
                                  className="btn btn-link fontSizeClass  m-2"
                                  data-toggle="collapse"
                                  data-target="#collapse5"
                                  aria-expanded="true"
                                  aria-controls="collapse5"
                                >
                                  5. When will action be taken on my complaint?
                                </button>
                              </div>
                              <div
                                id="collapse5"
                                class="collapse"
                                aria-labelledby="heading5"
                                data-parent="#accordion"
                              >
                                <div class="card-body m-3">
                                  Within a period of more or less 7 days an
                                  inspection would be carried out with respect
                                  to the complaint.
                                </div>
                              </div>
                            </div>
                            <div class="card">
                              <div className="card-header" id="heading6">
                                <button
                                  className="btn btn-link fontSizeClass  m-2"
                                  data-toggle="collapse"
                                  data-target="#collapse6"
                                  aria-expanded="true"
                                  aria-controls="collapse6"
                                >
                                  6. When will action be taken on my complaint?
                                </button>
                              </div>
                              <div
                                id="collapse6"
                                class="collapse"
                                aria-labelledby="heading6"
                                data-parent="#accordion"
                              >
                                <div class="card-body m-3">
                                  <div className=" health-dept-table">
                                    <table
                                      width="95%"
                                      border={0}
                                      align="center"
                                      cellPadding={2}
                                      cellSpacing={2}
                                      className="table table-bordered officials"
                                    >
                                      <tbody>
                                        <tr
                                          bgcolor="#302ba0"
                                          tabIndex={0}
                                          align="center"
                                          valign="middle"
                                        >
                                          <td
                                            width="20%"
                                            className="text-white tble-brder-left"
                                          >
                                            Sl.No.
                                          </td>
                                          <td
                                            width="40%"
                                            className="text-white"
                                          >
                                            Queries/complain
                                          </td>
                                          <td
                                            width="40%"
                                            className="text-white"
                                          >
                                            Immediate contract person
                                          </td>
                                        </tr>
                                        <tr
                                          tabIndex={0}
                                          align="left"
                                          valign="top"
                                        >
                                          <td>1.</td>
                                          <td>Chokage of Sewer Lines</td>
                                          <td>
                                            Concerned ward A.E./S.A.E.of civil
                                            dept.
                                          </td>
                                        </tr>
                                        <tr
                                          tabIndex={0}
                                          align="left"
                                          valign="top"
                                        >
                                          <td>2.</td>
                                          <td>
                                            Bulb/Fluorescent tube / vapor lamp
                                            not functioning.
                                          </td>
                                          <td>
                                            Local electrical maintenance staff
                                            of KMC or inform concerned ward
                                            AE/SAE (Electrical)
                                          </td>
                                        </tr>
                                        <tr
                                          tabIndex={0}
                                          align="left"
                                          valign="top"
                                        >
                                          <td>3.</td>
                                          <td>Break-down of Hand tube-wells</td>
                                          <td>
                                            Local tube well maintenance staff of
                                            KMC or inform concerned ward AE/SAE
                                            of tube well dept.
                                          </td>
                                        </tr>
                                        <tr
                                          tabIndex={0}
                                          align="left"
                                          valign="top"
                                        >
                                          <td>4.</td>
                                          <td>
                                            Problems regarding water stand posts
                                          </td>
                                          <td>
                                            Local ward AE/SAE (water supply)
                                          </td>
                                        </tr>
                                        <tr
                                          tabIndex={0}
                                          align="left"
                                          valign="top"
                                        >
                                          <td>5.</td>
                                          <td>
                                            Damage of manhole cover or gully pit
                                            or lamp hole or inspection pit
                                            cover.
                                          </td>
                                          <td>Local ward SAE.</td>
                                        </tr>
                                        <tr
                                          tabIndex={0}
                                          align="left"
                                          valign="top"
                                        >
                                          <td>6.</td>
                                          <td>
                                            Septic tank over flow in community
                                            toilets.
                                          </td>
                                          <td>
                                            Inform local C.O., or Block Sarkar.
                                          </td>
                                        </tr>
                                        <tr
                                          tabIndex={0}
                                          align="left"
                                          valign="top"
                                        >
                                          <td>7.</td>
                                          <td>
                                            Any other problem not covered above
                                          </td>
                                          <td>
                                            To be informed local Borough Office.
                                          </td>
                                        </tr>
                                        <tr
                                          tabIndex={0}
                                          align="left"
                                          valign="top"
                                        >
                                          <td>8.</td>
                                          <td>Pay & Use Toilet </td>
                                          <td>
                                            AE(C), ISP, Uttaran Services
                                            Department
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="card">
                              <div className="card-header" id="heading7">
                                <button
                                  className="btn btn-link fontSizeClass  m-2"
                                  data-toggle="collapse"
                                  data-target="#collapse7"
                                  aria-expanded="true"
                                  aria-controls="collapse7"
                                >
                                  7. If I need more information whom should I
                                  meet?
                                </button>
                              </div>
                              <div
                                id="collapse7"
                                class="collapse"
                                aria-labelledby="heading7"
                                data-parent="#accordion"
                              >
                                <div class="card-body m-3">
                                  Kindly meet D.G Uttaran Services, located at
                                  the Head Office of KMC, Hogg Buildings (3rd
                                  Floor), 1, Hogg Street, Kolkata -87. Phone No.
                                  : 22861280 (Extn: 2598).
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default KMC_Bustee_services;
